<template>
    <div>
        <app-contratacoes
            :contratacoes="contratacoes"
            v-show="mostrarContratacoes"
        >
            <template slot="filtros">
                <contratacoes-filtros
                    :servicos="obterServicos()"
                    perfil="gerente"
                    :filtros="filtros"
                    @atualizarFiltros="atualizarFiltros($event)"
                ></contratacoes-filtros>
            </template>
            <template slot="botoes">
                <b-row class="mt-2">
                    <b-col sm="12">
                        <div class="float-right">
                            <b-form-checkbox
                                v-model="apenasMinhasContratacoes"
                                :value="true"
                                :unchecked-value="false"
                                ><strong> APENAS MINHAS CONTRATAÇÕES</strong>
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-GER-CONT-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharContratacao(data.codContratacao)"
                    ></i>
                </span>
            </template>
        </app-contratacoes>
        <router-view></router-view>
    </div>
</template>

<script>
import ContratacoesServicos from './ContratacoesServicos'
import Contratacoes from '@/app/credenciados/componentes/contratacoes/Contratacoes'
import ContratacoesFiltros from '@/app/credenciados/componentes/contratacoes/ContratacoesFiltros'

export default {
    data() {
        return {
            contratacoes: [],
            apenasMinhasContratacoes: true,
            filtros: {
                unidade: -1,
                gestor: -1,
                situacao: -1,
                dataAte: new Date(new Date().getFullYear(), 11, 31),
                dataDe: new Date(new Date().getFullYear(), 0, 1)
            }
        }
    },
    methods: {
        obterContratacoes() {
            this.$store.dispatch('addRequest')
            let filtrosDto = {
                unidade: this.filtros.unidade,
                gestor: this.filtros.gestor,
                situacao: this.filtros.situacao,
                dataDe: this.filtros.dataDe
                    ? this.$moment(this.filtros.dataDe).format('YYYY-MM-DD')
                    : null,
                dataAte: this.filtros.dataAte
                    ? this.$moment(this.filtros.dataAte).format('YYYY-MM-DD')
                    : null,
                todas: !this.apenasMinhasContratacoes
            }
            ContratacoesServicos.obterTodas(filtrosDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratacoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharContratacao(id) {
            this.$router.push({
                name: `Gerentes_Contratacoes_Detalhar`,
                params: {
                    contratacaoId: id
                }
            })
        },

        obterServicos() {
            return ContratacoesServicos
        },

        atualizarFiltros(dados) {
            this.filtros = {
                unidade: dados.unidade,
                gestor: dados.gestor,
                situacao: dados.situacao,
                dataAte: dados.dataAte,
                dataDe: dados.dataDe
            }
            this.obterContratacoes()
        }
    },

    created() {
        this.obterContratacoes()
    },

    computed: {
        mostrarContratacoes() {
            return this.$route.name === 'Gerentes_Contratacoes'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Gerentes_Contratacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterContratacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        apenasMinhasContratacoes() {
            this.obterContratacoes()
        }
    },

    components: {
        AppContratacoes: Contratacoes,
        ContratacoesFiltros
    }
}
</script>
